declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1062622782706826'

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return // Already initialized

  // Meta Pixel base code
  const f: any = (window.fbq = function (...args: any[]) {
    f.callMethod ? f.callMethod(...args) : f.queue.push(args)
  })

  if (!window._fbq) window._fbq = f
  f.push = f
  f.loaded = true
  f.version = '2.0'
  f.queue = []

  // Load the pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Initialize pixel and fire PageView
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

// Track standard Meta Pixel events
export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  }
}

// Track custom events
export function trackCustomEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    if (params) {
      window.fbq('trackCustom', eventName, params)
    } else {
      window.fbq('trackCustom', eventName)
    }
  }
}
